/**
 * Canonical catalog of relay.notification event types — the nine values in the
 * relay.notifications CHECK constraint, with human-facing copy for the
 * preferences screen. Ordered most-actionable first.
 */

export interface NotificationEventDef {
  type: string;
  label: string;
  description: string;
  /** Whether email is on by default for this event when no row exists yet. */
  emailByDefault: boolean;
}

export const NOTIFICATION_EVENTS: NotificationEventDef[] = [
  {
    type: "hot_lead",
    label: "Hot lead",
    description: "A contact's lead score crosses the hot threshold.",
    emailByDefault: true,
  },
  {
    type: "deal_created",
    label: "New deal",
    description: "A deal is created in your pipeline.",
    emailByDefault: false,
  },
  {
    type: "deal_stage_changed",
    label: "Deal stage change",
    description: "A deal moves to a new pipeline stage.",
    emailByDefault: false,
  },
  {
    type: "deal_value_changed",
    label: "Deal value change",
    description: "A deal's value is updated.",
    emailByDefault: false,
  },
  {
    type: "email_reply",
    label: "Email reply",
    description: "A contact replies to one of your emails.",
    emailByDefault: true,
  },
  {
    type: "sequence_completed",
    label: "Sequence completed",
    description: "A contact finishes an email sequence.",
    emailByDefault: false,
  },
  {
    type: "new_contact",
    label: "New contact",
    description: "A contact is added to your CRM.",
    emailByDefault: false,
  },
  {
    type: "contact_updated",
    label: "Contact updated",
    description: "A contact's details change.",
    emailByDefault: false,
  },
  {
    type: "form_submission_triaged",
    label: "Form submission triaged",
    description: "AI triage is ready for a new form submission.",
    emailByDefault: false,
  },
  {
    type: "task_due",
    label: "Task due",
    description: "A task assigned to you is due.",
    emailByDefault: false,
  },
];

/**
 * Preferences-only email reports (UAT round 2, Wave 5). These are NOT
 * relay.notifications event types — no in-app row is ever written, so they
 * stay out of NOTIFICATION_EVENTS (whose card renders in-app/SMS semantics).
 * Consumers: relay._daily_pipeline_report_tick + the relay-job-runner
 * handler, which check `enabled` + the 'email' channel on the stored prefs.
 * Off by default — pure opt-in.
 */
export const EMAIL_REPORT_EVENTS: NotificationEventDef[] = [
  {
    type: "daily_pipeline_report",
    label: "Daily pipeline report",
    description:
      "A morning email summarizing your organization's open deals by pipeline stage.",
    emailByDefault: true,
  },
];
